export default __webpack_public_path__ + "static/media/avatar1.119ee58e.png";